import { PPStatusData } from "@/picking-portal/models/PPStatusData";
import { ElementColors } from "@/common/theme/ElementColors";

export enum PPOrderType {
  CLICK_AND_COLLECT = "CLICK_AND_COLLECT",
  DELIVERY = "DELIVERY",
}

const prefix = "modules.packing-portal.order.type.";

export const PPOrderTypeMap: Map<PPOrderType, PPStatusData> = new Map<PPOrderType, PPStatusData>([
  [PPOrderType.CLICK_AND_COLLECT, { text: `${prefix}click-and-collect`, color: ElementColors.Chip.ClickAndCollect }],
  [PPOrderType.DELIVERY, { text: `${prefix}delivery`, color: ElementColors.Chip.Delivery }],
]);
